import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PrerequisiteMission } from 'src/app/interfaces/mission.interface';
import { ConfigService } from 'src/app/services/config.service';


@Component({
  selector: 'app-mission',
  templateUrl: './mission.component.html',
  styleUrls: ['./mission.component.scss'],
})
export class MissionComponent implements OnInit {
  @Input() mission;
  missionState: string;
  customStateDict: any;
  showCustomResp: boolean = false;
  showStandardResp: boolean = false;

  prerequisiteMission: PrerequisiteMission;
  constructor(
    public router: Router,
    public configService: ConfigService
  ) { }
    
  isBlocked(){
    if (this.mission.prerequisite_mission) {
      if (this.mission.prerequisite_mission && (this.mission.prerequisite_mission.response_state != 'FINISHED' && this.mission.prerequisite_mission.response_state != 'APPROVED')) {
        return true;
      }
      return false;
    }
    return false;
  }

  ngOnInit() {
    this.customStateDict = this.configService.company_info.custom_state_dictionary;
    if (this.customStateDict) this.showCustomResp = true;
    if (this.mission.response_state in this.customStateDict) {
      this.missionState = this.customStateDict[this.mission.response_state];
    } else {
      this.showStandardResp = true;
    }
  }

  openMission(){
    this.router.navigate(['misiones/' + this.mission.id])
  }
  

}
